<li *ngFor="let enumClass of enumerationClasses"
    class="facet-contentlistitem"
    [ngClass]="{'facet-contentlistitem-selected': enumClass.isSelected}">

    <!-- Delete icon for empty classes -->
    <a *ngIf="facetPrivilege !== 'ReadOnly' && isSafeToDeleteEnumClass(enumClass) && !enumClass.ReadOnly"
       class="facet-list-item-link"
       (click)="removeClass(enumClass); false">
       <i class="fa fa-remove remove-item" title="Delete class"></i>
    </a>
    <span *ngIf="enumClass.isSelected">{{ enumClass.ClassName || "[Unnamed]" }}</span>

    <a *ngIf="!enumClass.isSelected"
       class="facet-list-item-link"
       (click)="selectClass(enumClass); false">{{ enumClass.ClassName || "[Unnamed]" }}</a>

    <info-tooltip *ngIf="enumClass.ReadOnly"
                  class="tool-tip"
                  [text]="'This entry is system generated and cannot be modified.
                  Enumeration values can be added and removed as needed'"></info-tooltip>
</li>
